import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QueryParams } from 'renderer/shared/schemas/common.schemas';

type TransactionsState = QueryParams;

const initialState: TransactionsState = {
  page: 1,
  limit: 10,
  sortBy: 'createdAt',
  sortOrder: 'desc',
  search: '',
};

const resetReducer: CaseReducer<TransactionsState> = () => {
  return initialState;
};

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState: initialState as TransactionsState,
  reducers: {
    resetTransactionsTable: resetReducer,
    setTransactionQuery: (state, { payload }: PayloadAction<QueryParams>) => {
      return payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { resetTransactionsTable, setTransactionQuery } =
  transactionSlice.actions;

export default transactionSlice.reducer;
